import React from "react"
import { FaHome, FaStar, FaMailBulk, FaTools } from "react-icons/fa"
import { MdVideoLibrary } from "react-icons/md"
import { RiPaintFill } from "react-icons/ri"
import '../styles/nav.css'
import Cursor from "./blink-cursor"
import { Link } from "gatsby"

function Header() {
    return (
        <nav class="navbar is-transparent has-shadow is-spaced" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
            <Link to="/">
                <a class="navbar-item">
                    {/* wintermutedigital@~/{(window.location.href).split("/")[(window.location.href).split.length+1]} */}
                    wintermutedigital.com@~/
                    <Cursor />

                </a>
            </Link>
                <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>

            <div id="navbarBasicExample" class="navbar-menu">
                <div class="navbar-end" >
                    <Link to="/">
                        <a class="navbar-item custom-underline">
                            <FaHome />
                            <span class="">&nbsp; home</span>
                        </a>
                    </Link>
                    {/* <Link to="/blog/">
                        <a class="navbar-item custom-underline">
                            <FaHome />
                            <span class="">&nbsp; blog</span>
                        </a>
                    </Link> */}

                    <Link to="/tutorials/">
                        <a class="navbar-item custom-underline">
                            <MdVideoLibrary />
                            <span class="">&nbsp; tutorials</span>
                        </a>
                    </Link>

                    <Link to="/projects/">

                        <a class="navbar-item custom-underline">
                            <RiPaintFill />
                            <span class="">&nbsp; my work</span>
                        </a>
                    </Link>
                    <Link to="/toolkit/">

                        <a class="navbar-item custom-underline">
                            <FaTools />
                            <span class="">&nbsp; toolkit</span>
                        </a>
                    </Link>
                    <Link to="/contact/">

                        <a class="navbar-item custom-underline">
                            <FaMailBulk />
                            <span className="">&nbsp; contact/hire</span>
                        </a>
                    </Link>

                </div>
            </div>
        </nav >
    );
}

export default Header;